/**
 * @param {HTMLElement} element
 * @returns {HTMLIFrameElement}
 */
export const toIframe = element => {
    const iframe = document.createElement('iframe');
    for (let i = 0; i < element.attributes.length; i++) {
        const n = element.attributes[i].name;
        iframe.setAttribute(n === 'data-src' ? 'src' : n, element.attributes[i].value);
    }
    element.parentNode.insertBefore(iframe, element);
    element.parentNode.removeChild(element);
    return iframe;
};
